import { popupStore } from '../../../../store/popupStore';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isMobile } from '../../../../core/helpers/isMobile';
import { isTopC } from '../../../../core/helpers/skinHelper';
import { PopupTypes } from '../../../../core/constants/popupTypes';

import defaultBlockWeb from '../../../../assets/images/fastTrade/default-web.png';
import selectedBlockWeb from '../../../../assets/images/fastTrade/selected-web.png';
import disabledBlockWeb from '../../../../assets/images/fastTrade/disable-web.png';
import winBlockWeb from '../../../../assets/images/fastTrade/win-web.png';
import selectedArrowWeb from '../../../../assets/images/fastTrade/selected-arrow-web.png';
import defaultArrowWeb from '../../../../assets/images/fastTrade/default-arrow-web.png';
import Bitcoin from '../../../../assets/images/cryptocurrency/BTC.png';
import defaultBlockMob from '../../../../assets/images/fastTrade/default-mob.png';
import selectedBlockMob from '../../../../assets/images/fastTrade/selected-mob.png';
import disabledBlockMob from '../../../../assets/images/fastTrade/disable-mob.png';
import winBlockMob from '../../../../assets/images/fastTrade/win-mob.png';
import selectedArrowMob from '../../../../assets/images/fastTrade/selected-arrow-mob.png';
import gameBgWeb from '../../../../assets/images/fastTrade/game-bg-web.png';
import gameBgMob from '../../../../assets/images/fastTrade/game-bg-mob.png';
import defaultArrowMob from '../../../../assets/images/fastTrade/default-arrow-mob.png';
import pointerBgWeb from '../../../../assets/images/fastTrade/pointer-bg-web.png';
import pointerBgMob from '../../../../assets/images/fastTrade/pointer-bg-mob.png';
import overMarketDefault from '../../../../assets/images/fastTrade/over-default.png';
import underMarketDefault from '../../../../assets/images/fastTrade/under-default.png';
import overMarketDefaultMob from '../../../../assets/images/fastTrade/over-default-mob.png';
import underMarketDefaultMob from '../../../../assets/images/fastTrade/under-default-mob.png';
import actionSelected from '../../../../assets/images/fastTrade/action-selected.png';
import actionSelectedMob from '../../../../assets/images/fastTrade/action-selected-mob.png';
import actionWin from '../../../../assets/images/fastTrade/action-win.png';
import actionWinMob from '../../../../assets/images/fastTrade/action-win-mob.png';
import actionDisable from '../../../../assets/images/fastTrade/disable-action.png';
import actionDisableMob from '../../../../assets/images/fastTrade/disable-action-mob.png';
import overDisable from '../../../../assets/images/fastTrade/over-disable.png';
import overDisableMob from '../../../../assets/images/fastTrade/over-disable-mob.png';
import underDisable from '../../../../assets/images/fastTrade/under-disable.png';
import underDisableMob from '../../../../assets/images/fastTrade/under-disable-mob.png';
import underArrowWeb from '../../../../assets/images/fastTrade/under-arrow-web.png';
import underArrowMob from '../../../../assets/images/fastTrade/under-arrow-mob.png';
import overArrowWeb from '../../../../assets/images/fastTrade/over-arrow-web.png';
import overArrowMob from '../../../../assets/images/fastTrade/over-arrow-mob.png';
import { soundService } from '../../../../services/baseSoundService/soundService';

export const FAST_TRADE_GAME_ID = 104;

export const marketTypes = {
  under: 0,
  over: 1,
  range: 2,
};

export const FastTradeGameSize = {
  width: isMobile() ? 500 : 1080,
  height: isMobile() ? 500 : 680,
};

export const fastTradeCountdownDeductionValues = {
  deductionValue: 1,
  intervalDelay: 1000,
  precision: 0,
};

export const ChartBlockConfigs = {
  bgScale1: isMobile() ? 0.5 : 1,
  bgScale2: isMobile() ? 0.5 : 1,
  bgAnchor1X: isMobile() ? 0.5 : 0.5,
  bgAnchor2X: isMobile() ? 0 : 0,
  bg1Y: isMobile() ? -35 : -46,
  bg2Y: isMobile() ? -35 : -46,
  parentContainerX: isMobile() ? -170 : -100,
  parentContainerY: isMobile() ? -10 : -10,
  deleteUnnecessaryDotsCount: isMobile() ? 8 : 23,
  webWidth: 120,
  mobWidth: 68,
  webHeight: 42,
  mobHeight: 27,
  dotGrowth: isMobile() ? 6 : 8,
  webFirstBetBlockX: 661.5,
  mobFirstBetBlockX: 320,
  webFirstBetBlockY: 212,
  mobFirstBetBlockY: 164,
  winBlockColor: 'rgba(252, 213, 53, 1)',
  selectedBlockColor: 'rgba(143, 153, 233, 1)',
};

export const gameImages = {
  gameBg: isMobile() ? gameBgMob : gameBgWeb,
  defaultBlock: isMobile() ? defaultBlockMob : defaultBlockWeb,
  selectedBlock: isMobile() ? selectedBlockMob : selectedBlockWeb,
  disabledBlock: isMobile() ? disabledBlockMob : disabledBlockWeb,
  winBlock: isMobile() ? winBlockMob : winBlockWeb,
  selectedArrow: isMobile() ? selectedArrowMob : selectedArrowWeb,
  defaultArrow: isMobile() ? defaultArrowMob : defaultArrowWeb,
  pointerBg: isMobile() ? pointerBgMob : pointerBgWeb,
  overDefault: isMobile() ? overMarketDefaultMob : overMarketDefault,
  underDefault: isMobile() ? underMarketDefaultMob : underMarketDefault,
  actionSelected: isMobile() ? actionSelectedMob : actionSelected,
  actionWin: isMobile() ? actionWinMob : actionWin,
  actionDisable: isMobile() ? actionDisableMob : actionDisable,
  underDisable: isMobile() ? underDisableMob : underDisable,
  overDisable: isMobile() ? overDisableMob : overDisable,
  underArrow: isMobile() ? underArrowMob : underArrowWeb,
  overArrow: isMobile() ? overArrowMob : overArrowWeb,
  Bitcoin,
};

export const fastTradeCanvasTranslations = {
  over: TranslationKeys.Over,
  under: TranslationKeys.Under,
};

export const chartBlockStyles = {
  oddTextStyleWeb: {
    fontFamily: 'Orbitron',
    fontSize: 12,
    fontWeight: 900,
    lineHeight: 15.05,
    fill: 0xffffff, // White color
    align: 'center',
    letterSpacing: 1,
  },
  oddTextStyleMob: {
    fontFamily: 'Orbitron',
    fontSize: 7,
    fontWeight: 900,
    lineHeight: 10.03,
    fill: 0xffffff, // White color
    align: 'center',
    letterSpacing: 1,
  },
  actionNameStyle: {
    fontFamily: 'Poppins',
    fontSize: isMobile() ? 14 : 18,
    fontWeight: 400,
    lineHeight: isMobile() ? 21 : 27,
    fill: 0xffffff,
    align: 'center',
    // letterSpacing: 1,
  },
  oddTextX: isMobile() ? 5 : 15,
  oddTextY: isMobile() ? 3 : 6,
  actionOddTextX: isMobile() ? 15 : 20,
  actionOddTextY: isMobile() ? 10 : 15,
  amountTextStyleWeb: {
    fontFamily: 'Orbitron',
    fontSize: 12,
    fontWeight: 900,
    lineHeight: 15.05,
    fill: '#FBAE19',
    align: 'center',
    letterSpacing: 1,
  },
  amountTextStyleMob: {
    fontFamily: 'Orbitron',
    fontSize: 7,
    fontWeight: 900,
    lineHeight: 10.03,
    fill: '#FBAE19',
    align: 'center',
    letterSpacing: 1,
  },
  pointerStylesWeb: {
    fontFamily: 'Orbitron',
    fontWeight: 800,
    fontSize: 18,
    lineHeight: 22.57,
    letterSpacing: 2,
    fill: 0xffffff,
  },
  pointerStylesMob: {
    fontFamily: 'Orbitron',
    fontWeight: 800,
    fontSize: 12,
    lineHeight: 22.57,
    letterSpacing: 2,
    fill: 0xffffff,
  },
  chartLinePointerStylesWeb: {
    fontFamily: 'Orbitron',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 14.06,
    fill: 'rgba(252, 213, 53, 0.4)', // White color
    align: 'center',
    letterSpacing: 1,
  },
  chartLinePointerStylesMob: {
    fontFamily: 'Orbitron',
    fontSize: 8,
    fontWeight: 400,
    lineHeight: 9.38,
    fill: 'rgba(252, 213, 53, 0.4)', // White color
    align: 'center',
    letterSpacing: 1,
  },
  pointerPivotX: isMobile() ? 52 : 83,
  pointerPivotY: isMobile() ? 9.5 : 14.5,
  pointerX: isMobile() ? 23 : 33,
  pointerY: isMobile() ? 9 : 15,
  amountTextX: isMobile() ? 5 : 15,
  amountTextY: isMobile() ? 14 : 22,
  actionAmountTextX: isMobile() ? 15 : 20,
  actionAmountTextY: isMobile() ? 25 : 30,
  currencyImgY: isMobile() ? 16 : 23.5,
  currencyScale: isMobile() ? 0.15 : 0.2,
  actionContainerOverX: isMobile() ? 200 : 360,
  actionContainerUnderX: isMobile() ? 370 : 635,
  actionContainerY: isMobile() ? 445 : 605,
  actionNameX: isMobile() ? 90 : 140,
  actionNameY: isMobile() ? 22 : 25,
  actionArrowX: isMobile() ? 5 : 5,
  actionArrowY: isMobile() ? -10 : -12,
};

export const fastTradeAnimationSourceNames = {
  win: 'win',
};
export const fastTradeAnimationNames = {
  win: 'win',
  winAction: 'win2Big',
};

export const gameResources = () => {
  const sourcePg = 'fastTrade';
  const fastTradeAnimationSourcesWeb = {
    win: {
      name: fastTradeAnimationSourceNames.win,
      path: `animations/${sourcePg}/web/win.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/${sourcePg}/web/win.atlas`,
        },
      },
    },
  };

  return [...Object.values(fastTradeAnimationSourcesWeb)];
};

export const FastTradeLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const FastTradeBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'roundId',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.resultSalt,
            key: spinInfo.resultKey,
            hash: spinInfo.resultHash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Market,
    dataKey: 'default1',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    additionalInfoRenderer: (spinInfo, t) => {
      if (spinInfo.additionalParams.markets.length > 1) {
        return (
          <span
            className='multi-selection'
            onClick={(e) => {
              e.stopPropagation();
              popupStore.open({ name: PopupTypes.Fairness, spinInfo });
              checkHashStore.setSpinInfo({
                salt: spinInfo.resultSalt,
                key: spinInfo.resultKey,
                hash: spinInfo.resultHash,
              });
            }}
          >
            {t(TranslationKeys.MultiSelection)}
          </span>
        );
      }
      if (spinInfo.additionalParams.markets[0].marketType === marketTypes.range) {
        return (
          <p>
            {spinInfo.additionalParams.markets[0].point} -{' '}
            {spinInfo.additionalParams.markets[0].point + 5}
          </p>
        );
      }
      return (
        <p>
          {spinInfo.additionalParams.markets[0].marketType === marketTypes.over
            ? t(TranslationKeys.Over)
            : t(TranslationKeys.Under)}
        </p>
      );
    },
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const FAST_TRADE_RULES_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
export const FAST_TRADE_ABOUT_HASH_KEYS = new Array(20).fill(null).map((item, index) => index + 1);

export const FastTradeSoundsName = {
  bgMusic: 'bg-music',
  timer: 'timer',
  betBlock: 'betBlock',
};

export const FastTradeSoundsPath = [
  {
    src: 'audio/fastTrade/background.mp3',
    name: FastTradeSoundsName.bgMusic,
    autoplay: false,
    html5: true,
    loop: false,
    buffer: true,
    onplay: function () {
      this._sounds[0]._node.bufferTime = 0.5; // need it for safari
    },
    onend: function () {
      soundService.play(FastTradeSoundsName.bgMusic);
    },
  },
  {
    src: 'audio/fastTrade/timer.mp3',
    name: FastTradeSoundsName.timer,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/fastTrade/betBlock.mp3',
    name: FastTradeSoundsName.betBlock,
    autoplay: false,
    html5: true,
  },
];
